import {endPointPrivate} from './config'
import axios from 'axios'

export default {
  listarSelect: (parametros) => {
    return axios.get(endPointPrivate + 'v1/cliente?termo=' + parametros.termo + '&uf=' + parametros.uf + '&cidade=' + parametros.cidade)
  },
  editCliente: (parametros) => {
    return axios.get(endPointPrivate + 'v1/cliente/' + parametros.id + '/' + parametros.codCliente + '/' + parametros.clienteNovo)
  },
  selecionar: () => {
    return axios.get(endPointPrivate + 'v1/dadosTabelasCliente')
  },
  verificaCNPJ: (parametro) => {
    return axios.get(endPointPrivate + 'v1/cliente/' + parametro)
  },
  salvar: (dados) => {
    return axios.post(endPointPrivate + 'v1/cliente', dados)
  }
}



// WEBPACK FOOTER //
// ./src/services/tableClientes.js